export default function formatLicenseNumber(licenceNumber: string) {
  let num = licenceNumber.split("-").join("")
  if (num.length === 7) {
    num = num.slice(0, 2) + "-" + num.slice(2, 5) + "-" + num.slice(5, 7)
  } else {
    num = num.slice(0, 3) + "-" + num.slice(3, 5) + "-" + num.slice(5, 8)
  }
  return num
}
